import { Space } from 'antd';
import { useCallback } from 'react';

import { CopyButton } from 'components/CopyButton';
import { DownloadButton } from 'components/DownloadButton';

import { Controls as StyledControls, Panel } from './Controls.style';
import { Levels } from './Levels';
import { ResetControl } from './Reset';
import { RotateControl } from './Rotate';
import { ZoomControl } from './Zoom';

/**
 * This component is deprecated in favor of horizon/components/Images/ImageViewer.
 *
 * The rtv1:new_image_viewer release toggle has been removed, but this component
 * could not be deleted with it: it is still used by the deprecated ImageViewer in
 * this directory, which retains consumers. Delete alongside that component.
 *
 * Further maintenance should not be needed, check with Riley with any questions.
 */

interface ControlsProps {
  onChange: (arg: any) => void;
  copyText: string;
  downloadHref: string;
  children: React.ReactNode;
  value?: {
    rotate: boolean;
    levels: { url: string; width: number; height: number }[];
  };
  homography?: number[];
}
export function Controls({
  onChange,
  copyText,
  downloadHref,
  children,
  value,
  homography,
  ...props
}: ControlsProps) {
  const rotate = value?.rotate;
  const levels = value?.levels;

  const handleChange = useCallback(
    (e) => {
      onChange && onChange(e);
    },
    [onChange]
  );

  return (
    <StyledControls {...props}>
      <Panel>
        <Space.Compact style={{ margin: '0 0.5rem 0.5rem 0' }}>
          <ZoomControl onChange={handleChange} />
          <RotateControl onChange={handleChange} value={rotate} disabled={!homography} />
          <ResetControl onChange={handleChange} />

          {downloadHref && <DownloadButton href={downloadHref} />}

          {copyText && <CopyButton value={copyText} legacy={true} />}
        </Space.Compact>

        {children}
      </Panel>

      <Panel style={{ textAlign: 'right' }}>
        {levels ? <Levels defaultValue={levels} onChange={handleChange} /> : null}
      </Panel>
    </StyledControls>
  );
}

export default Controls;
